
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/[uuid]",
      function () {
        return require("private-next-pages/share/[uuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/[uuid]"])
      });
    }
  